export default {"src":"/_next/static/media/CloseIcon.9c589b26.svg","height":15,"width":15,"blurWidth":0,"blurHeight":0};